angular.module('rjmNg.common.services').factory 'httpErrorHandler', [
  "$q"
  "$window"
  "$injector"
  "utils"
  "serviceUrl"
  "Raven"
  (
    $q
    $window
    $injector
    utils
    serviceUrl
    Raven
  ) ->
    # NOTE: Tokens is also a dependency but we use $injector to get it
    # in order to avoid a circular dependency error thrown by angular

    checkingTokenAuthorization = false

    response: (response) ->
      return response #do nothing on success

    handleUnauthorizedResponse = (rejection) ->
      $route = null
      if $injector.has("$route")
        $route = $injector.get("$route")

      # We don't need to redirect if we're on the login, signup, or invite pages.
      return if $route? and $route.current.inApp? and not $route.current.inApp

      if rejection.config.url is serviceUrl("/tokens/authenticate")
        $window.location = "/v2/session/create?redirect=#{$window.location}"

      else if not checkingTokenAuthorization
        checkingTokenAuthorization = true
        $injector.get("Tokens").get()
        .then () ->
          checkingTokenAuthorization = false

    responseError: (rejection) ->
      unless utils.requestWasCanceled(rejection) # do nothing if request was canceled
        switch rejection.status
          when 401,403
            handleUnauthorizedResponse(rejection)

          when 404
          else
            errorData = rejection
            if rejection.config?.params?.credentials?
              errorData = angular.copy rejection
              errorData.config.params.credentials = "REDACTED"

            try
              Raven?.captureException(
                new Error("#{rejection.config?.method} #{rejection.config?.url}"),
                {
                  extra: errorData,
                  fingerprint: [
                    '{{ default }}',
                    rejection.config?.url?.replace(/\/\d+\//g, '/#/'),
                    rejection.status]
                })

      $q.reject rejection
]
